import React, { useState } from "react";
import { RedButton } from "components/Buttons/buttonsStyles";
import { useDispatch } from "react-redux";
import { createTickerWorkspace } from "store/reducers/SettingsSlice";
import Error from "utils/Notifications/Error";
import BasedModal from "components/BaseModalComponents/BasedModal";

interface CreateWorkspaceModalProps {
    isOpen: boolean;
    onRequestClose: () => void;
}

const CreateWorkspaceModal: React.FC<CreateWorkspaceModalProps> = ({
    isOpen,
    onRequestClose,
}) => {
    const dispatch = useDispatch();
    const [name, setName] = useState("");

    const handleCreate = () => {
        const trimmed = name.trim();
        if (!trimmed) {
            Error("Имя не может быть пустым");
            return;
        }

        dispatch(createTickerWorkspace({
            name: trimmed,
            is_active: false,
            configs: []
        }));

        setName("");
        onRequestClose();
    };

    return (
        <BasedModal isOpen={isOpen} onRequestClose={onRequestClose}>
            <div style={{
                padding: "20px",
                background: "white",
                borderRadius: "10px",
                minWidth: "320px",
                display: "flex",
                flexDirection: "column",
                gap: "16px"
            }}>
                <h3 style={{ margin: 0, fontSize: "18px" }}>
                    Новая рабочая область
                </h3>

                <input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Введите имя"
                    autoFocus
                    style={{
                        padding: "10px 12px",
                        fontSize: "14px",
                        borderRadius: "6px",
                        border: "1px solid #d9d9d9",
                        outline: "none"
                    }}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") handleCreate();
                        if (e.key === "Escape") onRequestClose();
                    }}
                />

                <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                    <RedButton onClick={onRequestClose}>
                        Отмена
                    </RedButton>
                    <RedButton green onClick={handleCreate}>
                        Создать
                    </RedButton>
                </div>
            </div>
        </BasedModal>
    );
};

export default CreateWorkspaceModal;